// Powder snow (MB.1) — the freeze behaviour of the powder_snow block. PURE (ENG-1).
//
// Powder snow is the trap block: an entity without leather boots sinks into it and,
// after a submerged spell, takes freeze damage; leather boots let it walk on top and
// never freeze. The block is placed/scooped with a bucket (powder_snow_bucket <->
// bucket). This module owns the pure freeze maths the host runs each survival tick;
// the collision-side "walk on top" + slow-sink velocity stays a host/physics concern.

/** Ticks fully submerged before freeze damage begins (Java: 140 gt = 7 s). */
export const FREEZE_ONSET_TICKS = 140;
/** Once frozen, damage lands on this cadence (Java: every 40 gt = 2 s). */
export const FREEZE_DAMAGE_INTERVAL = 40;
/** Freeze damage per hit (Java 1, bypassing armour). */
export const FREEZE_DAMAGE = 1;
/** The frozen counter saturates here (drives the client's blue vignette). */
export const FREEZE_MAX_TICKS = FREEZE_ONSET_TICKS + FREEZE_DAMAGE_INTERVAL * 5;
/** Leaving powder snow thaws twice as fast as it froze (Java). */
export const THAW_RATE = 2;

/** An entity sinks into powder snow unless it wears leather boots (then it walks
 *  on top, as if the block were solid). */
export function sinksIn(hasLeatherBoots: boolean): boolean {
  return !hasLeatherBoots;
}

/** The frozen counter after one tick. Standing in powder snow without leather boots
 *  builds it toward the cap; anywhere else (or with leather boots) it thaws toward
 *  zero at THAW_RATE. */
export function freezeStep(frozen: number, inPowderSnow: boolean, hasLeatherBoots: boolean): number {
  const f = Math.max(0, Math.floor(frozen));
  if (inPowderSnow && !hasLeatherBoots) return Math.min(FREEZE_MAX_TICKS, f + 1);
  return Math.max(0, f - THAW_RATE);
}

/** Freeze damage to apply on the tick the counter reaches `frozen` (0 for none).
 *  Only past the onset, and only on the damage cadence — the first hit lands the
 *  instant the counter reaches the onset. */
export function freezeDamage(frozen: number): number {
  if (frozen < FREEZE_ONSET_TICKS) return 0;
  return (frozen - FREEZE_ONSET_TICKS) % FREEZE_DAMAGE_INTERVAL === 0 ? FREEZE_DAMAGE : 0;
}
